import * as React from 'react';
import { Grid, Nav, Navbar, NavItem, Panel } from 'react-bootstrap';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';
import LinkContainer from 'react-router-bootstrap/lib/LinkContainer';
import withTracker from '../../with_tracker';
import HaltestellenMonitorComponent from './fahrgast_components/haltestellen_monitor_component';
import ImpressumComponent from './fahrgast_components/impressum_component';
import LinieComponent from './fahrgast_components/linie_component';
import "./fahrgast_components/my-navbar.css";
import { LemgoDigitalLogo, StadtbusLogo } from './stadtbus_logo';
import StopMap from './stop_map/stop_map';
// import TimetableChangeEntry from './timetable_change_entry';

interface IFahrgastComponentsProps extends Partial<RouteComponentProps<{}>> {
}

class FahrgastComponent extends React.Component<IFahrgastComponentsProps> {

  public render() {
    const pjson = require('../../../package.json');
    return <div>
      <Navbar style={{marginBottom: "0px"}} collapseOnSelect={true}>
        <Navbar.Header>
          <Navbar.Brand style={{padding: 0}}>
            {(this.props.location!.pathname.indexOf("haltestellen") === -1) && (
              <button type="button" className="navbarBrandButton" onClick={() => this.props.history!.goBack()}>
                <span className="glyphicon glyphicon-arrow-left"/>
              </button>
            )}
          </Navbar.Brand>
          <Navbar.Brand style={{padding: 0}}>
            <StadtbusLogo style={{margin: '8px 5px', padding: '7px 0px', height: 34}}/> 
            <LemgoDigitalLogo style={{margin: '8px 5px', padding: '7px 0px', height: 34}}/>
          </Navbar.Brand>
          <Navbar.Toggle/>
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <LinkContainer to={`${process.env.PUBLIC_URL}${this.props.match!.url}/haltestellen`}>
              <NavItem>
                Haltestellen
              </NavItem>
            </LinkContainer>
            <LinkContainer to={`${process.env.PUBLIC_URL}${this.props.match!.url}/karte`}>
              <NavItem>
                Karte
              </NavItem>
            </LinkContainer>
            <NavItem href="https://dashboard.lemgo-digital.de/static_content/Beschreibung.pdf" target="_blank">
              Beschreibung
            </NavItem>
            <NavItem href="mailto:fahrgastapp-feedback@lemgo-digital.de">
              Feedback einreichen
            </NavItem>
            <LinkContainer to={`${process.env.PUBLIC_URL}${this.props.match!.url}/impressum`}>
              <NavItem>
                Impressum
              </NavItem>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <div className="versionIndicator">
        Pilotversion: {pjson.version}
      </div>
      <div className="container">
        <div className="container notification">
          {/* <TimetableChangeEntry>
            {{
              aheader: <div>Baumaßnahmen auf der STADTBUS-Linie 1</div>,
              body: <div>
                      <p>Vom 12.10. bis 04.11.2020 werden &quot;Braker Schule&quot;, &quot;Schiefe Breite&quot; und &quot;Wasserfurche&quot; nicht angefahren. Bitte nutzen Sie in dieser Zeit die Haltestellen &quot;Innovation Campus&quot; oder &quot;Braker Mitte&quot;.</p>
                    </div>
            }}
          </TimetableChangeEntry> */}
          <Panel>
            <Panel.Heading>
              <Panel.Title>
                Bitte <a className="link" target="_blank" rel="noopener noreferrer" href="https://www.stadtbus-lemgo.de/">Fahrplanänderungen</a> beachten.
                </Panel.Title>
            </Panel.Heading>
          </Panel>
          <Panel>
            <Panel.Heading>
              <Panel.Title>
                Die STADTBUS-Web-Anwendung wird zum <b>30.09.2026</b> abgeschaltet und durch die neue Mobilitäts-Web-App SMAP für Lemgo bzw. „STADTBUS-Live“ abgelöst. <br />
				Die neue Anwendung könnt ihr ab sofort unter dem folgenden Link ansehen: <a className="link" target="_blank" rel="noopener noreferrer" href="https://www.stadtbus-lemgo.de/stadtbus-lemgo/auskunft/stadtbus-live/">https://www.stadtbus-lemgo.de/stadtbus-lemgo/auskunft/stadtbus-live/</a> bzw. als App downloaden.
              </Panel.Title>
            </Panel.Heading>
          </Panel>
        </div>
      </div>
      <Grid>
        <Switch>
          <Route path={`${process.env.PUBLIC_URL}${this.props.match!.url}/haltestellen/:stopID?`}
                 component={withTracker(HaltestellenMonitorComponent)}/>
          <Route path={`${process.env.PUBLIC_URL}${this.props.match!.url}/linie/:tripID/:stopID?`}
                 component={withTracker(LinieComponent)}/>
          <Route path={`${process.env.PUBLIC_URL}${this.props.match!.url}/karte/:lat?/:lng?/:zoom?`}
                 component={withTracker(StopMap)}/>
          <Route path={`${process.env.PUBLIC_URL}${this.props.match!.url}/impressum`}
                 component={withTracker(ImpressumComponent)}/>
          <Redirect to={`${process.env.PUBLIC_URL}${this.props.match!.url}/haltestellen`}/>
        </Switch>
        <div style={{margin: "auto", width: "33%"}}>
          <a href="https://www.lemgo-digital.de/" target="_blank">
            <LemgoDigitalLogo style={{paddingBottom: 16}} width={'100%'}/>
          </a>
        </div>
      </Grid>
    </div>;
  }
}

export default FahrgastComponent;



// WEBPACK FOOTER //
// ./src/components/stadtbus/fahrgast_component.tsx